export default __webpack_public_path__ + "static/media/qr-template-large-icon-es.ef7e8425.png";